export const types = {
  CAD_VIEWER_APPEND_VISIBLE_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_APPEND_VISIBLE_BODIES',
  CAD_VIEWER_RECEIVE_ACTIVE_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_ACTIVE_BODIES',
  CAD_VIEWER_RECEIVE_ASSEMBLY_TREE_DATA:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_ASSEMBLY_TREE_DATA',
  CAD_VIEWER_RECEIVE_DISPLAY_SCALE:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_DISPLAY_SCALE',
  CAD_VIEWER_RECEIVE_DISPLAY_UNITS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_DISPLAY_UNITS',
  CAD_VIEWER_RECEIVE_DIMENSIONAL_PRECISION:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_DIMENSIONAL_PRECISION',
  CAD_VIEWER_RECEIVE_DISPLAY_WEIGHT_UNITS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_DISPLAY_WEIGHT_UNITS',
  CAD_VIEWER_RECEIVE_ENABLED_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_ENABLED_BODIES',
  CAD_VIEWER_RECEIVE_EXPANDED_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_EXPANDED_BODIES',
  CAD_VIEWER_RECEIVE_FOCUSED_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_FOCUSED_BODIES',
  CAD_VIEWER_RECEIVE_FOCUSED_UUID:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_FOCUSED_UUID',
  CAD_VIEWER_RECEIVE_FORCE_FOCUS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_FORCE_FOCUS',
  CAD_VIEWER_RECEIVE_FORCE_VIEW:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_FORCE_VIEW',
  CAD_VIEWER_RECEIVE_GEOMETRIC_DOCUMENT_HASH:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_GEOMETRIC_DOCUMENT_HASH',
  CAD_VIEWER_RECEIVE_HAS_PMI_ANNOTATIONS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_HAS_PMI_ANNOTATIONS',
  CAD_VIEWER_RECEIVE_HIGHLIGHT:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_HIGHLIGHT',
  CAD_VIEWER_RECEIVE_HOVER_BODY:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_HOVER_BODY',
  CAD_VIEWER_RECEIVE_INTERROGATION_INFO:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_INTERROGATION_INFO',
  CAD_VIEWER_RECEIVE_META_DATA:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_META_DATA',
  CAD_VIEWER_RECEIVE_NATIVE_UNITS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_NATIVE_UNITS',
  CAD_VIEWER_RECEIVE_PART_FILE:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_PART_FILE',
  CAD_VIEWER_RECEIVE_PROCESS_TAG:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_PROCESS_TAG',
  CAD_VIEWER_RECEIVE_SELECTED_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_SELECTED_BODIES',
  CAD_VIEWER_RECEIVE_SHOW_DXF_CONTROLS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_SHOW_DXF_CONTROLS',
  CAD_VIEWER_RECEIVE_SHOW_ADDITIONAL_KEYS:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_SHOW_ADDITIONAL_KEYS',
  CAD_VIEWER_RECEIVE_SHOW_ADDITIONAL_KEYS_EXPLICIT:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_SHOW_ADDITIONAL_KEYS_EXPLICIT',
  CAD_VIEWER_RECEIVE_TEMPORARILY_SIMPLIFIED:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_TEMPORARILY_SIMPLIFIED',
  CAD_VIEWER_RECEIVE_TOO_COMPLEX:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_TOO_COMPLEX',
  CAD_VIEWER_RECEIVE_VISIBLE_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_RECEIVE_VISIBLE_BODIES',
  CAD_VIEWER_REMOVE_VISIBLE_BODIES:
    'common/viewer/cadViewer/CAD_VIEWER_REMOVE_VISIBLE_BODIES',
  CAD_VIEWER_RESET: 'common/viewer/cadViewer/CAD_VIEWER_RESET',
  CAD_VIEWER_TOGGLE_SELECTED_FEATURES:
    'common/viewer/cadViewer/CAD_VIEWER_TOGGLE_SELECTED_FEATURES',
  CAD_VIEWER_SET_GEOMETRIC_ENTITIES:
    'common/viewer/cadViewer/CAD_VIEWER_SET_GEOMETRIC_ENTITIES',
  CAD_VIEWER_SET_RENDER_NATIVE_COLORS:
    'common/viewer/cadViewer/CAD_VIEWER_SET_RENDER_NATIVE_COLORS',
  DIMENSION_TOOL_TOGGLE: 'common/viewer/cadViewer/DIMENSION_TOOL_TOGGLE',
  EXPLODED_VIEW_TOOL_DISABLE:
    'common/viewer/cadViewer/EXPLODED_VIEW_TOOL_DISABLE',
  EXPLODED_VIEW_TOOL_RECEIVE_EXPLODED_STATE:
    'common/viewer/cadViewer/EXPLODED_VIEW_TOOL_RECEIVE_EXPLODED_STATE',
  EXPLODED_VIEW_TOOL_TOGGLE:
    'common/viewer/cadViewer/EXPLODED_VIEW_TOOL_TOGGLE',
  FEATURE_SELECTION_RECEIVE:
    'common/viewer/cadViewer/FEATURE_SELECTION_RECEIVE',
  FEATURE_SNAP_TO_RECEIVE: 'common/viewer/cadViewer/FEATURE_SNAP_TO_RECEIVE',
  FEATURE_SNAP_TO_REQUEST: 'common/viewer/cadViewer/FEATURE_SNAP_TO_REQUEST',
  FOCUSED_VIEW_TOGGLE: 'common/viewer/cadViewer/FOCUSED_VIEW_TOGGLE',
  GEOMETRIC_PART_FILE_BULK_PREPARE:
    'common/viewer/cadViewer/GEOMETRIC_PART_FILE_BULK_PREPARE',
  HIGHLIGHT_VIEW_TOGGLE: 'common/viewer/cadViewer/HIGHLIGHT_VIEW_TOGGLE',
  MANUFACTURABILITY_FEEDBACK_SELECTION_RECEIVE:
    'common/viewer/cadViewer/MANUFACTURABILITY_FEEDBACK_SELECTION_RECEIVE',
  MATERIAL_STOCK_CREATE_FAILED:
    'common/viewer/cadViewer/MATERIAL_STOCK_CREATE_FAILED',
  MATERIAL_STOCK_CREATE_SUCCESS:
    'common/viewer/cadViewer/MATERIAL_STOCK_CREATE_SUCCESS',
  MATERIAL_STOCK_FINISH_NESTING_CREATION:
    'common/viewer/cadViewer/MATERIAL_STOCK_FINISH_NESTING_CREATION',
  MATERIAL_STOCK_RECEIVE_NEW_RESULT:
    'common/viewer/cadViewer/MATERIAL_STOCK_RECEIVE_NEW_RESULT',
  MATERIAL_STOCK_RECEIVE_VISIBLE_KEYS:
    'common/viewer/cadViewer/MATERIAL_STOCK_RECEIVE_VISIBLE_KEYS',
  MEASUREMENT_TOOL_TOGGLE: 'common/viewer/cadViewer/MEASUREMENT_TOOL_TOGGLE',
  MEASUREMENT_TOOL_RECEIVE_COMPARISON:
    'common/viewer/cadViewer/MEASUREMENT_TOOL_RECEIVE_COMPARISON',
  MEASUREMENT_TOOL_RECEIVE_SELECTIONS:
    'common/viewer/cadViewer/MEASUREMENT_TOOL_RECEIVE_SELECTIONS',
  MEASUREMENT_TOOL_REMOVE_SELECTIONS:
    'common/viewer/cadViewer/MEASUREMENT_TOOL_REMOVE_SELECTIONS',
  MEASUREMENT_TOOL_RECEIVE_MEASUREMENT:
    'common/viewer/cadViewer/MEASUREMENT_TOOL_RECEIVE_MEASUREMENT',
  MEASUREMENT_TOOL_ENABLE: 'common/viewer/cadViewer/MEASUREMENT_TOOL_ENABLE',
  MEASUREMENT_TOOL_DISABLE: 'common/viewer/cadViewer/MEASUREMENT_TOOL_DISABLE',
  MEASUREMENT_OBJECTS_MANAGER_RECEIVE_SELECTIONS:
    'common/viewer/cadViewer/MEASUREMENT_OBJECTS_MANAGER_RECEIVE_SELECTIONS',
  MEASUREMENT_OBJECTS_MANAGER_REMOVE_SELECTIONS:
    'common/viewer/cadViewer/MEASUREMENT_OBJECTS_MANAGER_REMOVE_SELECTIONS',
  OPTIMAL_BOUNDING_BOX_TOOL_TOGGLE:
    'common/viewer/cadViewer/OPTIMAL_BOUNDING_BOX_TOOL_TOGGLE',
  PMI_VIEW_TOGGLE: 'common/viewer/cadViewer/PMI_VIEW_TOGGLE',
  PMI_VIEW_SHOW: 'common/viewer/cadViewer/PMI_VIEW_SHOW',
  PMI_VIEW_HIDE: 'common/viewer/cadViewer/PMI_VIEW_HIDE',
  RENDER_NATIVE_COLORS_TOGGLE:
    'common/viewer/cadViewer/RENDER_NATIVE_COLORS_TOGGLE',
  RESET_VIEW: 'common/viewer/cadViewer/RESET_VIEW',
  SELECTED_OBJECTS_MANAGER_RECEIVE_SELECTIONS:
    'common/viewer/cadViewer/SELECTED_OBJECTS_MANAGER_RECEIVE_SELECTIONS',
  SELECTED_OBJECTS_MANAGER_REMOVE_ALL_SELECTIONS:
    'common/viewer/cadViewer/SELECTED_OBJECTS_MANAGER_REMOVE_ALL_SELECTIONS',
  SELECTED_OBJECTS_MANAGER_REMOVE_SELECTIONS:
    'common/viewer/cadViewer/SELECTED_OBJECTS_MANAGER_REMOVE_SELECTIONS',
  SELECTOR_TOOL_BOX_SELECT: 'common/viewer/cadViewer/SELECTOR_TOOL_BOX_SELECT',
  SELECTOR_TOOL_CLEAR_ALL_SELECTIONS:
    'common/viewer/cadViewer/SELECTOR_TOOL_CLEAR_ALL_SELECTIONS',
  SELECTOR_TOOL_DISABLE: 'common/viewer/cadViewer/SELECTOR_TOOL_DISABLE',
  SELECTOR_TOOL_ENABLE: 'common/viewer/cadViewer/SELECTOR_TOOL_ENABLE',
  SELECTOR_TOOL_RECEIVE_CUMULATIVE_INFO:
    'common/viewer/cadViewer/SELECTOR_TOOL_RECEIVE_CUMULATIVE_INFO',
  SELECTOR_TOOL_RECEIVE_SELECTION:
    'common/viewer/cadViewer/SELECTOR_TOOL_RECEIVE_SELECTION',
  SELECTOR_TOOL_REMOVE_SELECTION:
    'common/viewer/cadViewer/SELECTOR_TOOL_REMOVE_SELECTION',
  SELECTOR_TOOL_REMOVE_SELECTIONS:
    'common/viewer/cadViewer/SELECTOR_TOOL_REMOVE_SELECTIONS',
  SELECTOR_TOOL_TOGGLE: 'common/viewer/cadViewer/SELECTOR_TOOL_TOGGLE',
  SET_GEOMETRIC_INTERACTION_READY:
    'common/viewer/cadViewer/SET_GEOMETRIC_INTERACTION_READY',
  VIEWER_INTERACTIONS_FOCUS_ON_BODIES:
    'common/viewer/cadViewer/VIEWER_INTERACTIONS_FOCUS_ON_BODIES',
  VIEWER_INTERACTIONS_FOCUS_ON_PART_FILE:
    'common/viewer/cadViewer/VIEWER_INTERACTIONS_FOCUS_ON_PART_FILE',
  VIEWER_INTERACTIONS_HIDE_VIEWER_BODY:
    'common/viewer/cadViewer/VIEWER_INTERACTIONS_HIDE_VIEWER_BODY',
  VIEWER_INTERACTIONS_ISOLATE_BODIES:
    'common/viewer/cadViewer/VIEWER_INTERACTIONS_ISOLATE_BODIES',
  VIEWER_INTERACTIONS_SHOW_ALL_COMPONENTS:
    'common/viewer/cadViewer/VIEWER_INTERACTIONS_SHOW_ALL_COMPONENTS',
  VIEWER_PART_FILE_QUEUE_LOAD_SUCCESS:
    'common/viewer/cadViewer/VIEWER_PART_FILE_QUEUE_LOAD_SUCCESS',
  VIEWER_PART_FILE_QUEUE_PENDING_ADD_TO_END:
    'common/viewer/cadViewer/VIEWER_PART_FILE_QUEUE_PENDING_ADD_TO_END',
  VIEWER_PART_FILE_QUEUE_PENDING_ADD_TO_START:
    'common/viewer/cadViewer/VIEWER_PART_FILE_QUEUE_PENDING_ADD_TO_START',
  VIEWER_STATE_CAPTURE_NEXT_STATE_REQUEST:
    'common/viewer/cadViewer/VIEWER_STATE_CAPTURE_NEXT_STATE_REQUEST',
  VIEWER_STATE_RECEIVE: 'common/viewer/cadViewer/VIEWER_STATE_RECEIVE',
  VIEWER_STATE_SNAP_TO: 'common/viewer/cadViewer/VIEWER_STATE_SNAP_TO',
  VIEWER_STATE_RESET: 'common/viewer/cadViewer/VIEWER_STATE_RESET',
  WIRE_FRAME_TOOL_TOGGLE: 'common/viewer/cadViewer/WIRE_FRAME_TOOL_TOGGLE',
};

export const cadViewer = {
  appendVisibleBodies: ({ visibleBodies }) => ({
    type: types.CAD_VIEWER_APPEND_VISIBLE_BODIES,
    payload: { visibleBodies },
  }),
  receiveActiveBodies: ({ activeBodies }) => ({
    type: types.CAD_VIEWER_RECEIVE_ACTIVE_BODIES,
    payload: { activeBodies },
  }),
  receiveDisplayScale: ({ displayScale }) => ({
    type: types.CAD_VIEWER_RECEIVE_DISPLAY_SCALE,
    payload: { displayScale },
  }),
  receiveDisplayUnits: ({ displayUnits }) => ({
    type: types.CAD_VIEWER_RECEIVE_DISPLAY_UNITS,
    payload: { displayUnits },
  }),
  receiveDimensionalPrecision: ({ dimensionalPrecision }) => ({
    type: types.CAD_VIEWER_RECEIVE_DIMENSIONAL_PRECISION,
    payload: { dimensionalPrecision },
  }),
  receiveDisplayWeightUnits: ({ displayWeightUnits }) => ({
    type: types.CAD_VIEWER_RECEIVE_DISPLAY_WEIGHT_UNITS,
    payload: { displayWeightUnits },
  }),
  setRenderNativeColors: ({ renderNativeColors }) => ({
    type: types.CAD_VIEWER_SET_RENDER_NATIVE_COLORS,
    payload: { renderNativeColors },
  }),
  receiveEnabledBodies: ({ enabledBodies }) => ({
    type: types.CAD_VIEWER_RECEIVE_ENABLED_BODIES,
    payload: { enabledBodies },
  }),
  receiveExpandedBodies: ({ expandedBodies }) => ({
    type: types.CAD_VIEWER_RECEIVE_EXPANDED_BODIES,
    payload: { expandedBodies },
  }),
  receiveFocusedBodies: ({ focusedBodies }) => ({
    type: types.CAD_VIEWER_RECEIVE_FOCUSED_BODIES,
    payload: { focusedBodies },
  }),
  receiveFocusedUuid: ({ focusedUuid }) => ({
    type: types.CAD_VIEWER_RECEIVE_FOCUSED_UUID,
    payload: { focusedUuid },
  }),
  receiveForceFocus: ({ forceFocus }) => ({
    type: types.CAD_VIEWER_RECEIVE_FORCE_FOCUS,
    payload: { forceFocus },
  }),
  receiveForceView: ({ forceView }) => ({
    type: types.CAD_VIEWER_RECEIVE_FORCE_VIEW,
    payload: { forceView },
  }),
  receiveHighlight: ({ highlight }) => ({
    type: types.CAD_VIEWER_RECEIVE_HIGHLIGHT,
    payload: { highlight },
  }),
  receiveHoverBody: ({ hoverBody }) => ({
    type: types.CAD_VIEWER_RECEIVE_HOVER_BODY,
    payload: { hoverBody },
  }),
  receiveInterrogationInfo: ({ documentHash, interrogationFileId, task }) => ({
    type: types.CAD_VIEWER_RECEIVE_INTERROGATION_INFO,
    payload: { documentHash, interrogationFileId, task },
  }),
  receiveMetaData: ({ metaData }) => ({
    type: types.CAD_VIEWER_RECEIVE_META_DATA,
    payload: { metaData },
  }),
  receiveNativeUnits: ({ nativeUnits }) => ({
    type: types.CAD_VIEWER_RECEIVE_NATIVE_UNITS,
    payload: { nativeUnits },
  }),
  receivePartFile: ({
    file,
    shouldFocus,
    shouldPropagateVisibility,
    ignoreQueue,
  }) => ({
    type: types.CAD_VIEWER_RECEIVE_PART_FILE,
    payload: { file, shouldFocus, shouldPropagateVisibility, ignoreQueue },
  }),
  receiveSelectedBodies: ({ selectedBodies }) => ({
    type: types.CAD_VIEWER_RECEIVE_SELECTED_BODIES,
    payload: { selectedBodies },
  }),
  receiveShowAdditionalKeys: ({ showAdditionalKeys }) => ({
    type: types.CAD_VIEWER_RECEIVE_SHOW_ADDITIONAL_KEYS,
    payload: { showAdditionalKeys },
  }),
  receiveShowAdditionalKeysExplicit: ({ showAdditionalKeysExplicit }) => ({
    type: types.CAD_VIEWER_RECEIVE_SHOW_ADDITIONAL_KEYS_EXPLICIT,
    payload: { showAdditionalKeysExplicit },
  }),
  receiveShowDxfControls: ({ showDxfControls }) => ({
    type: types.CAD_VIEWER_RECEIVE_SHOW_DXF_CONTROLS,
    payload: { showDxfControls },
  }),
  receiveVisibleBodies: ({ visibleBodies }) => ({
    type: types.CAD_VIEWER_RECEIVE_VISIBLE_BODIES,
    payload: { visibleBodies },
  }),
  receiveTemporarilySimplified: ({
    temporarilySimplified,
    temporarilySimplifiedParts,
  }) => ({
    type: types.CAD_VIEWER_RECEIVE_TEMPORARILY_SIMPLIFIED,
    payload: { temporarilySimplified, temporarilySimplifiedParts },
  }),
  receiveTooComplexForPartViewer: ({ tooComplex }) => ({
    type: types.CAD_VIEWER_RECEIVE_TOO_COMPLEX,
    payload: { tooComplex },
  }),
  removeVisibleBodies: ({ viewerIds }) => ({
    type: types.CAD_VIEWER_REMOVE_VISIBLE_BODIES,
    payload: { viewerIds },
  }),
  reset: () => ({
    type: types.CAD_VIEWER_RESET,
  }),
  setInteractionReady: ({ isReady }) => ({
    type: types.SET_GEOMETRIC_INTERACTION_READY,
    payload: { isReady },
  }),
  setGeometricEntities: ({ showAdditionalKeysExplicit }) => ({
    type: types.CAD_VIEWER_SET_GEOMETRIC_ENTITIES,
    payload: { showAdditionalKeysExplicit },
  }),
};

export const dimensionTool = {
  toggle: () => ({
    type: types.DIMENSION_TOOL_TOGGLE,
  }),
};

export const optimalBoundingBoxTool = {
  toggle: () => ({
    type: types.OPTIMAL_BOUNDING_BOX_TOOL_TOGGLE,
  }),
};

export const explodedViewTool = {
  disable: () => ({
    type: types.EXPLODED_VIEW_TOOL_DISABLE,
  }),
  receiveExplodedState: ({ assemblyInstanceId, factor }) => ({
    type: types.EXPLODED_VIEW_TOOL_RECEIVE_EXPLODED_STATE,
    payload: { assemblyInstanceId, factor },
  }),
  toggle: () => ({
    type: types.EXPLODED_VIEW_TOOL_TOGGLE,
  }),
};

export const featureSelection = {
  receive: ({ features }) => ({
    type: types.FEATURE_SELECTION_RECEIVE,
    payload: { features },
  }),
};

export const featureSnapTo = {
  request: ({ feature }) => ({
    type: types.FEATURE_SNAP_TO_REQUEST,
    payload: { feature },
  }),
  receive: ({ feature }) => ({
    type: types.FEATURE_SNAP_TO_RECEIVE,
    payload: { feature },
  }),
};

export const geometricPartFile = {
  bulkPrepare: ({ partFileUuids }) => ({
    type: types.GEOMETRIC_PART_FILE_BULK_PREPARE,
    payload: { partFileUuids },
  }),
};

export const materialStock = {
  createFailed: ({ resultKey }) => ({
    type: types.MATERIAL_STOCK_CREATE_FAILED,
    payload: { resultKey },
  }),
  createSuccess: ({ resultKey }) => ({
    type: types.MATERIAL_STOCK_CREATE_SUCCESS,
    payload: { resultKey },
  }),
  finishNestingCreation: ({ result }) => ({
    type: types.MATERIAL_STOCK_FINISH_NESTING_CREATION,
    payload: { result },
  }),
  receiveNewResult: ({ result }) => ({
    type: types.MATERIAL_STOCK_RECEIVE_NEW_RESULT,
    payload: { result },
  }),
  receiveVisibleResultKeys: ({ resultKeys }) => ({
    type: types.MATERIAL_STOCK_RECEIVE_VISIBLE_KEYS,
    payload: { resultKeys },
  }),
};

export const measurementObjectsManager = {
  receiveSelections: ({ caliperObjects }) => ({
    type: types.MEASUREMENT_OBJECTS_MANAGER_RECEIVE_SELECTIONS,
    payload: { caliperObjects },
  }),
  removeSelections: () => ({
    type: types.MEASUREMENT_OBJECTS_MANAGER_REMOVE_SELECTIONS,
  }),
};

export const measurementTool = {
  disable: () => ({
    type: types.MEASUREMENT_TOOL_DISABLE,
  }),
  enable: () => ({
    type: types.MEASUREMENT_TOOL_ENABLE,
  }),
  receiveComparison: ({ comparison }) => ({
    type: types.MEASUREMENT_TOOL_RECEIVE_COMPARISON,
    payload: { comparison },
  }),
  receiveSelections: ({ selections, viewerState }) => ({
    type: types.MEASUREMENT_TOOL_RECEIVE_SELECTIONS,
    payload: { selections, viewerState },
  }),
  removeSelections: () => ({
    type: types.MEASUREMENT_TOOL_REMOVE_SELECTIONS,
  }),
  receiveMeasurement: ({ distance }) => ({
    type: types.MEASUREMENT_TOOL_RECEIVE_MEASUREMENT,
    payload: { distance },
  }),
  toggle: () => ({
    type: types.MEASUREMENT_TOOL_TOGGLE,
  }),
};

export const manufacturabilityFeedbackSelection = {
  receive: ({ manufacturabilityFeedback }) => ({
    type: types.MANUFACTURABILITY_FEEDBACK_SELECTION_RECEIVE,
    payload: { manufacturabilityFeedback },
  }),
};

export const selectedObjectsManager = {
  receiveSelections: ({ selections }) => ({
    type: types.SELECTED_OBJECTS_MANAGER_RECEIVE_SELECTIONS,
    payload: { selections },
  }),
  removeAllSelections: () => ({
    type: types.SELECTED_OBJECTS_MANAGER_REMOVE_ALL_SELECTIONS,
  }),
  removeSelections: ({ selections }) => ({
    type: types.SELECTED_OBJECTS_MANAGER_REMOVE_SELECTIONS,
    payload: { selections },
  }),
};

export const selectorTool = {
  boxSelect: ({ selections }) => ({
    type: types.SELECTOR_TOOL_BOX_SELECT,
    payload: { selections },
  }),
  clearAllSelections: () => ({
    type: types.SELECTOR_TOOL_CLEAR_ALL_SELECTIONS,
  }),
  disable: () => ({
    type: types.SELECTOR_TOOL_DISABLE,
  }),
  enable: () => ({
    type: types.SELECTOR_TOOL_ENABLE,
  }),
  receiveCumulativeInfo: ({ cumulativeInfo }) => ({
    type: types.SELECTOR_TOOL_RECEIVE_CUMULATIVE_INFO,
    payload: { cumulativeInfo },
  }),
  receiveSelection: ({ selection }) => ({
    type: types.SELECTOR_TOOL_RECEIVE_SELECTION,
    payload: { selection },
  }),
  removeSelection: ({ f, obj }) => ({
    type: types.SELECTOR_TOOL_REMOVE_SELECTION,
    payload: { f, obj },
  }),
  toggle: () => ({
    type: types.SELECTOR_TOOL_TOGGLE,
  }),
};

export const wireFrameTool = {
  toggle: () => ({
    type: types.WIRE_FRAME_TOOL_TOGGLE,
  }),
};

export const resetView = () => ({
  type: types.RESET_VIEW,
});

export const highlightViewTool = {
  toggle: () => ({
    type: types.HIGHLIGHT_VIEW_TOGGLE,
  }),
};

export const pmiViewTool = {
  show: () => ({
    type: types.PMI_VIEW_SHOW,
  }),
  hide: () => ({
    type: types.PMI_VIEW_HIDE,
  }),
  toggle: () => ({
    type: types.PMI_VIEW_TOGGLE,
  }),
  receiveHasPMIAnnotations: ({ hasPMIAnnotations }) => ({
    type: types.CAD_VIEWER_RECEIVE_HAS_PMI_ANNOTATIONS,
    payload: { hasPMIAnnotations },
  }),
};

export const renderNativeColorsTool = {
  toggle: () => ({
    type: types.RENDER_NATIVE_COLORS_TOGGLE,
  }),
};

export const focusedViewToggle = () => ({
  type: types.FOCUSED_VIEW_TOGGLE,
});

/*
The viewer state is being constantly passed from the viewer to the viewer component.
When you need access to the viewer state, first you will set the flag to capture the
next step. Upon setting the flag, the CAD Viewer will trigger the receiveState action
to store the state in the redux store where it can be accessed by any listeners.
*/
export const viewerState = {
  captureNextStateRequest: () => ({
    type: types.VIEWER_STATE_CAPTURE_NEXT_STATE_REQUEST,
  }),
  receiveState: ({ viewerState }) => ({
    // maybe this should not set the value in the store but just let someone 'take' it?
    type: types.VIEWER_STATE_RECEIVE,
    payload: { viewerState },
  }),
  snapToState: ({ viewerState, cadViewerState }) => ({
    type: types.VIEWER_STATE_SNAP_TO,
    payload: { viewerState, cadViewerState },
  }),
  reset: () => ({
    type: types.VIEWER_STATE_RESET,
  }),
};

export const viewerPartFileQueue = {
  loadSuccess: ({ partFileUuid }) => ({
    type: types.VIEWER_PART_FILE_QUEUE_LOAD_SUCCESS,
    payload: { partFileUuid },
  }),
  pendingQueueAddToEnd: ({ partFileUuid }) => ({
    type: types.VIEWER_PART_FILE_QUEUE_PENDING_ADD_TO_END,
    payload: { partFileUuid },
  }),
  pendingQueueAddToStart: ({ partFileUuid }) => ({
    type: types.VIEWER_PART_FILE_QUEUE_PENDING_ADD_TO_START,
    payload: { partFileUuid },
  }),
};

export const viewerInteractions = {
  focusOnBodies: ({ viewerBodyIds }) => ({
    type: types.VIEWER_INTERACTIONS_FOCUS_ON_BODIES,
    payload: { viewerBodyIds },
  }),
  focusOnPartFile: ({ partFileUuid }) => ({
    type: types.VIEWER_INTERACTIONS_FOCUS_ON_PART_FILE,
    payload: { partFileUuid },
  }),
  hideViewerBody: ({ viewerBodyId }) => ({
    type: types.VIEWER_INTERACTIONS_HIDE_VIEWER_BODY,
    payload: { viewerBodyId },
  }),
  isolateBodies: ({ viewerBodyIds }) => ({
    type: types.VIEWER_INTERACTIONS_ISOLATE_BODIES,
    payload: { viewerBodyIds },
  }),
  showAllComponents: () => ({
    type: types.VIEWER_INTERACTIONS_SHOW_ALL_COMPONENTS,
  }),
};
